const initialState = {
    isRemovingSequence: false,
    isHandlingReassign: false,
    isReadingTasks: false,
    tasksInfo: null
}

export default initialState;
